class Validation {
    constructor(){
    }
    
    validateFromRefs(refsList){
        let isValid = true;
        const refsKeys = Object.keys(refsList)
        if(refsKeys.length == 0) return isValid;

        refsKeys.forEach((refKey) => {
            if(refsList[refKey]){
                if(Array.isArray(refsList[refKey])){
                    refsList[refKey].forEach((ref) => {
                        if(!this._validateComponent(ref)) isValid = false
                    })
                } else {
                    if(!this._validateComponent(refsList[refKey])) isValid = false
                }
            }
        })

        return isValid
    }

    _validateComponent(component){
        return component.validate();
    }
}

export default new Validation()